export default {
  name: 'yueyang',
  adcode: '430600',
  mapName: '岳阳市',
  geoJsonPath: 'hunanmap/430600.json',
  backgroundImage: {
    png: '岳阳市_430600.png',
    webp: '岳阳市_430600.webp'
  },
  echartsMapStyle: {
    width: '875px',
    height: '657px',
    marginTop: 'auto',
    marginBottom: '79px',
  },
  imageSize: {
    width: 4040,
    height: 3032
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.31, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.002,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表（岳阳市）
  districts: [
    '岳阳市区',
    '岳阳县',
    '华容县',
    '湘阴县',
    '平江县',
    '汨罗市',
    '临湘市'
  ],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（兜底）
    '岳阳市区': [113.032, 29.424],
    '岳阳市': [113.122, 29.370],
    '岳阳县': [113.272, 29.144],
    '华容县': [112.448, 29.500],
    '湘阴县': [112.725, 28.720],
    '平江县': [113.660, 28.785],
    '汨罗市': [113.027, 28.843],
    '临湘市': [113.450, 29.475]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '岳阳市') return '岳阳市区'
    return s
  },
  // 区县与adcode映射（岳阳市）
  cityAdcodeMap: {
    '岳阳楼区': '430602',
    '云溪区': '430603',
    '君山区': '430611',
    '岳阳县': '430621',
    '华容县': '430623',
    '湘阴县': '430624',
    '平江县': '430626',
    '汨罗市': '430681',
    '临湘市': '430682'
  }
}